// extracted by mini-css-extract-plugin
export default {"flightWrapper":"styles_flightWrapper__e3iah","infoRow":"styles_infoRow__jSP15","overview":"styles_overview__JjDkQ","lopaKey":"styles_lopaKey__qbzpH","event":"styles_event__fJoew"};